import betway from "./betway";
import marca from "./marca";
import bet365 from "./bet365";
import betonline from "./betonline";
import bwin from "./bwin";
import williamhill from "./williamhill";
import codere from "./codere";
import botemania from "./botemania";
import luckia from "./luckia";
import apuestas10 from "./apuestas10";
import apuestas11 from "./apuestas11";
import apuestas12 from "./apuestas12";

export default {
    //betway: betway,
    opiniones_marca_apuestas: marca,
    //bet365: bet365,
    //betonline: betonline,
    //bwin: bwin,
    //williamhill: williamhill,
    bono_codere: codere,
    bono_botemania: botemania,
    bono_luckia: luckia,
    //apuestas10: apuestas10,
    //apuestas11: apuestas11,
    //apuestas12: apuestas12
}
